import React, { useState, useEffect } from "react";
import { Stack, TextField, Button } from "@mui/material";
import { useData } from "../hooks/useData";

const ProjectName = () => {
  const { projectName, setProjectName } = useData();
  const [inputValue, setInputValue] = useState(projectName || "");
  const [nameError, setNameError] = useState("");

  // Sync inputValue with projectName when it changes
  useEffect(() => {
    setInputValue(projectName || "");
    setNameError(""); // Reset error when projectName changes
  }, [projectName]);

  // Name validation (same as RenameProjectDialog)
  const maxNameLength = 50;
  const nameRegex = /^[a-zA-Z0-9\s\-_]*$/; // Allow empty input during typing
  const validateName = (name) => {
    if (name.length > maxNameLength) {
      return `Project name must be ${maxNameLength} characters or less.`;
    }
    if (name && !nameRegex.test(name)) {
      return "Project name can only contain letters, numbers, spaces, hyphens, and underscores.";
    }
    return "";
  };

  const handleInputChange = (e) => {
    const updatedName = e.target.value;
    setInputValue(updatedName);
    setNameError(validateName(updatedName));
  };

  const handleSaveClick = () => {
    if (nameError || inputValue.trim() === "" || inputValue === projectName)
      return;
    setProjectName(inputValue);
  };

  // Disable Save button if input is invalid, empty, or unchanged
  const isSaveDisabled =
    !!nameError || inputValue.trim() === "" || inputValue === projectName;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <TextField
        id="projectName"
        placeholder="Name This Design"
        value={inputValue}
        onChange={handleInputChange}
        variant="outlined"
        size="small"
        error={!!nameError}
        helperText={nameError}
        sx={{
          "& .MuiInputBase-root": {
            fontFamily: "Roboto",
            fontSize: "0.875rem",
            bgcolor: "white",
            borderRadius: "4px",
          },
          width: 180,
        }}
      />
      <Button
        variant="outlined"
        onClick={handleSaveClick}
        disabled={isSaveDisabled}
        sx={{
          textTransform: "none",
          fontFamily: "Roboto",
          height: 32,
          color: "primary.main",
          borderColor: "primary.main",
          "&:hover": { borderColor: "primary.dark", color: "primary.dark" },
          "&.Mui-disabled": {
            borderColor: "grey.400",
            color: "grey.400",
          },
        }}
      >
        Save
      </Button>
    </Stack>
  );
};

export default ProjectName;
